import { render, staticRenderFns } from "./LoansActive.vue?vue&type=template&id=1bc898a7"
import script from "./LoansActive.vue?vue&type=script&lang=js"
export * from "./LoansActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports